module.exports = function getResource(label, vars = []) {
    let resources = {
        allStores: 'All Stores',
        chooseLocation: 'Choose a location'
    };
    return resources[label];
};
